import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { RiskTone } from "../components/common/RiskBadge";

type ResourceKind = "money" | "reputation" | "xp" | "skill_points";

const resourceMessages: Record<ResourceKind, MessageDescriptor> = {
  money: msg`Зарабатываешь на контрактах. Тратишь в разделе Инструменты - они помогают в задачах.`,
  reputation: msg`Растёт за хорошие отчёты и высокие оценки. Открывает новых клиентов и сложные контракты.`,
  xp: msg`Опыт (XP) копится за каждый контракт. Набрал порог - уровень растёт и открывает контракты посложнее.`,
  skill_points: msg`Даются за новые уровни. Вкладываешь в Навыки - они облегчают задачи.`,
};

const toneMessages: Record<RiskTone, MessageDescriptor> = {
  low: msg`Низкий уровень - обычно безопасно.`,
  secure: msg`Низкий уровень - обычно безопасно.`,
  medium: msg`Средний - стоит проверить.`,
  high: msg`Высокий - вероятная проблема.`,
  critical: msg`Критический - серьёзная угроза.`,
  info: msg`Справочная пометка.`,
};

export function resourceTooltip(kind: ResourceKind): MessageDescriptor {
  return resourceMessages[kind];
}

const difficultyMessage: MessageDescriptor =
  msg`Сложность контракта 1-3. Выше - труднее задачи и больше награда.`;

const rewardMessage: MessageDescriptor =
  msg`Итог зависит от твоей оценки: множитель от 0.2 (Failed) до 1.2 (S).`;

const trustMessage: MessageDescriptor =
  msg`Доверие клиента: его отношение к тебе. Растёт за высокие оценки, падает за провалы, за повтор контракта не меняется. С доверия 70 клиент платит +10% к награде, высокое доверие даёт достижение «Доверенный партнёр».`;

const costMessage: MessageDescriptor =
  msg`Стоимость меры. Тратит бюджет клиента - уложись в него, выбирая самое значимое.`;

export function difficultyTooltip(): MessageDescriptor {
  return difficultyMessage;
}

export function rewardTooltip(): MessageDescriptor {
  return rewardMessage;
}

export function trustTooltip(): MessageDescriptor {
  return trustMessage;
}

export function costTooltip(): MessageDescriptor {
  return costMessage;
}

export function toneTooltip(tone: RiskTone): MessageDescriptor {
  return toneMessages[tone];
}
